// TODO: @deprecated - remove
angular.module( 'acme.view.application.modals.confirm', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.modals.confirm.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var confirmModal = {
        name: 'application.modals.confirm',
        url: '/modals/confirm',
        views: {
          "main": {
            controller: 'ConfirmModalController',
            // Assumes the view is entirely self contained
            templateUrl: 'common/views/modals/confirm/confirm.tpl.html'
          }
        },
        data: {
          pageTitle: '  ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(confirmModal);
});
